import type { FC } from 'react'
import React from 'react'

import styled from '@emotion/styled'

import Button from '@segment/matcha/components/Button'

import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SignupButton from '@segment/matcha/recipes/SignupButton'

import LogoTiles from '@segment/templates/LogoTiles'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

const data = {
  heading: `Getting started is easy`,
  description: `Start connecting your data with Segment`,
}

const BaseGettingStarted: FC = () => {
  const pageConfig = usePageConfig()

  return (
    <Wrapper>
      <Copy>
        <CopyTextBase centered={true}>
          <CopyText.Heading tag="h2" variant="h2">
            {data.heading}
          </CopyText.Heading>
          <CopyText.Description tag="p" variant="pLarge" dangerouslySetInnerHTML={{ __html: data.description }} />
        </CopyTextBase>
        <Content>
          <Button size="large" color="primary" variant="outlined" tag="a" href={getAbsoluteUrl(`/demo/`, pageConfig)}>
            Get a demo
          </Button>
          <SignupButton tag="a" iconEnd={ChevronRightIcon}>
            Create a free account
          </SignupButton>
        </Content>
      </Copy>
      <LogoTiles />
    </Wrapper>
  )
}

export default BaseGettingStarted

export const Wrapper = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  background: ${({ theme }) => theme.palette.twilio.gray[10]};
`

export const Copy = styled.div`
  display: grid;
  justify-content: center;
  row-gap: 40px;
  padding: 40px 20px 0;

  ${({ theme }) => theme.breakpoints.up(`md`)} {
    padding: 80px 80px 30px;
  }
`

export const Content = styled.div`
  display: grid;
  max-width: 520px;
  width: 100%;
  margin: 0 auto;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  gap: 24px;

  ${({ theme }) => theme.breakpoints.down(`sm`)} {
    grid-template-columns: auto;
    max-width: 327px;
  }
`
